var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('layout-head'),(!_vm.$route.meta.hideBreadcrumb && _vm.$route.name !== 'home')?_c('layout-breadcrumb'):_vm._e(),_c('layout-main'),_c('layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }